import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import SideSection from "../../components/common/SideSection";
import MyPageSearchBar from "../../components/MyPage/MyPageSearchBar";
import backIcon from "../../assets/images/MusicSearchPage/arrow_back.svg";
import PinCalendarViewComponent from "../../components/MyPage/PinCalendarViewComponent";
import { useQuery } from "@tanstack/react-query";
import { searchPin } from "../../services/api/myPage";

const MyPinSearchPage = ({ onSelectedLocation = () => {} }) => {
  const [inputValue, setInputValue] = useState();
  const [showSideBar, setShowSideBar] = useState(true);
  const [pinList, setPinList] = useState();
  const [init, setInit] = useState(true);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const loaderRef = useRef(null);

  // const [searchTriggered, setSearchTriggered] = useState(false);

  const navigate = useNavigate();
  const goMyPage = () => {
    navigate("/mypage");
  };

  // const handleSearch = () => {
  //   setSearchTriggered(true);
  // };

  // const { isError, data, error } = useQuery({
  //   queryKey: ["searchPin", inputValue],
  //   queryFn: () => searchPin({ keyword: inputValue }),
  //   keepPreviousData: true, // 데이터가 로딩 중에도 이전 데이터를 유지
  //   enabled: searchTriggered && inputValue.length > 0,
  // });

  // if (!data) {
  //   return <div>데이터가 없습니다.</div>;
  // }

  // if (isError) {
  //   console.error("Error fetching user info:", error);
  //   return <div>오류 발생: {error.message}</div>;
  // }

  const completeSearch = async () => {
    setInit(false);
    console.log(inputValue);
    const encodedKeyword = encodeURIComponent(inputValue);
    console.log(encodedKeyword);
    const res = await searchPin({ keyword: encodedKeyword, page: page });
    console.log(res);
    setPage(prev => prev + 1);
    setHasMore(res.myPinList.length === 20);
    setPinList(res.myPinList);
  };

  const loadMoreResults = async () => {
    console.log(hasMore);
    if (!hasMore) return;

    try {
      console.log("page:", page);
      const encodedKeyword = encodeURIComponent(inputValue);
      const data = await searchPin({ keyword: encodedKeyword, page: page });
      console.log("fetched Data:", data);
      setPinList(prev => [...prev, ...data.myPinList]);
      setPage(prev => prev + 1);
      setHasMore(data.myPinList.length === 20);
    } catch (error) {
      console.error("핀피드 조회 에러: ", error);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        console.log(entries);

        if (entries[0].isIntersecting) {
          console.log("로딩");
          loadMoreResults(); // 스크롤 끝까지 내릴 때 추가 데이터 요청
        }
      },
      {
        root: null, // 기본값 viewport
        rootMargin: " 0px 0px 100px 0px",
        threshold: 0, // 0%에서 호출
      },
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }
    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [page, hasMore]);

  return (
    <SideSection showSideBar={showSideBar}>
      <BackIcon src={backIcon} onClick={goMyPage} />
      <Content>
        <MyPageSearchBar
          inputValue={inputValue}
          setInputValue={setInputValue}
          completeSearch={completeSearch}
        />
        {pinList ? (
          pinList.map(it => (
            <PinCalendarViewComponent
              title={it.songInfo.title}
              artist={it.songInfo.artist}
              imgPath={it.songInfo.imgPath}
              genreName={it.genreName}
              listenedDate={it.listenedDate}
              placeName={it.placeName}
              songId={it.songInfo.songId}
              latitude={it.latitude}
              longitude={it.longitude}
              onSelectedLocation={onSelectedLocation}
            />
          ))
        ) : (
          <Empty>
            <EmptyMessage>{init ? "" : "검색 결과가 없습니다."}</EmptyMessage>
          </Empty>
        )}
        <div ref={loaderRef} style={{ height: "15px" }}></div>
      </Content>
    </SideSection>
  );
};

export default MyPinSearchPage;

const BackIcon = styled.img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  cursor: pointer;
  padding-left: 34px;
  padding-top: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 22px;
  padding-bottom: 31px;
`;

const Empty = styled.div`
  height: calc(100vh - 285px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EmptyMessage = styled.div`
  color: var(--gray02, rgb(116, 116, 116));
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 28px */
`;
